import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { Box, AspectRatio, Badge, useColorModeValue } from "@chakra-ui/react";

function Item({ node, loading, hideText = false }) {
  const bg = useColorModeValue("white", "gray.900");
  return (
    <Box
      borderWidth="1px"
      borderRadius="lg"
      overflow="hidden"
      key={node.id}
      position="relative"
      bg={bg}
      boxShadow="sm"
    >
      <AspectRatio maxW="620px" ratio={4 / 3}>
        <GatsbyImage
          loading={loading}
          image={
            node.data.Attachments.localFiles[0].childImageSharp.gatsbyImageData
          }
          alt={node.data.Name}
        />
      </AspectRatio>

      {!hideText && (
        <Box py={2} px={2}>
          <Box d="flex" alignItems="baseline">
            {node?.data?.tags?.map((tag) => {
              return (
                <Badge
                  id={tag}
                  borderRadius="full"
                  px="2"
                  mr={1}
                  variant="subtle"
                  colorScheme="teal"
                >
                  {tag}
                </Badge>
              );
            })}
          </Box>
          <Box
            mt="1"
            fontWeight="semibold"
            as="h3"
            lineHeight="tight"
            isTruncated
            px={1}
          >
            {node.data.Name}
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default React.memo(Item);
